/**
 * 平台配置
 * 用于多租户/多品牌复用同一套代码
 *
 * 平台类型（来自数据库 xc_dep_config.platform_type）：
 * - report: 数据报告类（需要登录，默认路由 /reportPosterCenter）
 * - portal: 门户网站类（不需要登录，默认路由 /）
 */

// 平台类型配置
export const PLATFORM_TYPE_CONFIG = {
  // 数据报告类
  report: {
    requireLogin: true,
    afterLoginRoute: '/reportPosterCenter',
  },
  // 门户网站类
  portal: {
    requireLogin: false,
    afterLoginRoute: '/',
    aboutUs: null
  }
}

/**
 * 报告类租户 - 专家解读按钮配置
 * text: 按钮文字
 * path: 跳转路径（空字符串表示无跳转，显示禁用状态）
 */
export const REPORT_EXPERT_BTN_CONFIG = {
  hpmra: { text: '专家解读', path: '/jxt' },
  whicpa: { text: '专家解读', path: '/jxt' },
  zwrx: { text: '等待配置', path: '' },
  dewave: { text: '助贷服务', path: 'productCardList' },
}

/**
 * 根据平台类型获取配置
 * @param {string} platformType - 平台类型
 * @returns {object} 平台配置
 */
export function getPlatformTypeConfig(platformType) {
  return PLATFORM_TYPE_CONFIG[platformType] || PLATFORM_TYPE_CONFIG['portal']
}

import { getDepNameByDomain } from "@/utils/index"

/**
 * 从域名获取平台代码（等同于 getDepNameByDomain）
 * @returns {string} 平台代码/租户名
 */
export function getPlatformCodeByDomain() {
  return getDepNameByDomain()
}

export default {
  PLATFORM_TYPE_CONFIG,
  REPORT_EXPERT_BTN_CONFIG,
  getPlatformTypeConfig,
  getPlatformCodeByDomain
}



// WEBPACK FOOTER //
// ./src/config/platform.js